export default __webpack_public_path__ + "static/media/Initiate's Robes of the Moon.8a29a745.jpg";